import React, {useImperativeHandle, useRef, useState} from 'react';
import OrderAllowanceDialog from '@Local/Orders/Componetnets/OrderAllowanceDialog';
import OrderAllowanceVoidDialog from '@Local/Orders/Componetnets/OrderAllowanceVoidDialog';
import OrderAllowanceCancelDialog from '@Local/Orders/Componetnets/OrderAllowanceCancelDialog';
import OrderInvoiceReissuingDialog from '@Local/Orders/Componetnets/OrderInvoiceReissuingDialog';
import {isEqual} from '@Util/utils';

/**
 * 彈窗類型常數
 */
const ALLOWANCE_DIALOG = 'allowance_dialog';
const ALLOWANCE_VOID_DIALOG = 'allowance_void_dialog';
const ALLOWANCE_CANCEL_DIALOG = 'allowance_cancel_dialog';
const INVOICE_REISSUING_DIALOG = 'invoice_reissuing_dialog';

/**
 * 預設開啟的彈窗
 */
const defaultOpenDialog = "";

/**
 * 訂單彈窗管理組件
 *
 * 功能：
 * - 統一管理各種訂單相關彈窗
 * - 提供開啟不同彈窗的方法
 * - 支援彈窗狀態管理和資料傳遞
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {Object} ref - 組件引用
 * @returns {JSX.Element} 訂單彈窗管理組件
 */
const OrdersDialogBox = React.forwardRef((props, ref) => {
    const [openDialog, setOpenDialog] = useState(defaultOpenDialog);
    const sourceDataRef = useRef({});
    const refreshRef = useRef(null);

    /**
     * 執行刷新操作
     */
    const doRefresh = () => {
        if (refreshRef.current && typeof refreshRef.current === 'function') refreshRef.current();
    };

    useImperativeHandle(
        ref,
        () => {
            return {
                openOrderAllowanceDialog: (targetData = {}, _refreshFn = () => {
                }) => {
                    sourceDataRef.current = targetData;
                    refreshRef.current = _refreshFn;
                    setOpenDialog(ALLOWANCE_DIALOG);
                },
                openOrderAllowanceVoidDialog: (targetData = {}, _refreshFn = () => {
                }) => {
                    sourceDataRef.current = targetData;
                    refreshRef.current = _refreshFn;
                    setOpenDialog(ALLOWANCE_VOID_DIALOG);
                },
                openOrderAllowanceCancelDialog: (targetData = {}, _refreshFn = () => {
                }) => {
                    sourceDataRef.current = targetData;
                    refreshRef.current = _refreshFn;
                    setOpenDialog(ALLOWANCE_CANCEL_DIALOG);
                },
                openOrderInvoiceReissuingDialog: (targetData = {}, _refreshFn = () => {
                }) => {
                    sourceDataRef.current = targetData;
                    refreshRef.current = _refreshFn;
                    setOpenDialog(INVOICE_REISSUING_DIALOG);
                },
                closeDialog: () => handleCloseDialog(),
            };
        },
        // eslint-disable-next-line
        [],
    );

    const handleCloseDialog = () => {
        setOpenDialog('');
        refreshRef.current = null;
        sourceDataRef.current = {};
    };

    return (
        <>
            <OrderAllowanceDialog open={isEqual(openDialog, ALLOWANCE_DIALOG)} sourceData={sourceDataRef.current}
                                  onClose={handleCloseDialog} refresh={doRefresh}/>
            <OrderAllowanceVoidDialog open={isEqual(openDialog, ALLOWANCE_VOID_DIALOG)} sourceData={sourceDataRef.current}
                                      onClose={handleCloseDialog} refresh={doRefresh}/>
            <OrderAllowanceCancelDialog open={isEqual(openDialog, ALLOWANCE_CANCEL_DIALOG)} sourceData={sourceDataRef.current}
                                        onClose={handleCloseDialog} refresh={doRefresh}/>
            <OrderInvoiceReissuingDialog open={isEqual(openDialog, INVOICE_REISSUING_DIALOG)} sourceData={sourceDataRef.current}
                                         onClose={handleCloseDialog} refresh={doRefresh}/>
        </>
    )
});

export default OrdersDialogBox;
